import React from 'react';
import { observer } from 'mobx-react';
import {
  CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, AreaChart, Area
} from 'recharts';

import styles from './widgets.module.css';
import dashboardStore from '../../../stores/dashboard.store';
import { GraphTimeTick } from '../../common/graph_time_tick.component';
import ChartTooltip, { axisTickStyle } from './chart_tooltip.component';
import { deployMarkerLines } from './deploy_markers';

const LogsChartWidget = observer(() => {
  const { logSums } = dashboardStore;
  const logData = logSums.slice(); // linechart is checking if it is an array and it isn't because of mobx

  return (
    <div>
      <div className={styles.chartTitle}> Logs: </div>
      <ResponsiveContainer width="100%" height={170}>
        <AreaChart data={logData} syncId="dashboard">
          <Tooltip wrapperStyle={{zIndex:1}} content={<ChartTooltip/>}/>
          <Area type="monotone" dataKey="exception"   name="Exception"
            stackId="1" stroke="#000000" fill="#000000" />
          <Area type="monotone" dataKey="error" name="Error"
            stackId="1" stroke="#e51a41" fill="#e51a41" />
          <Area type="monotone" dataKey="warning" name="Warning"
            stackId="1" stroke="#ff7336" fill="#ff7336" />
          <Area type="monotone" dataKey="info" name="Info"
            stackId="1" stroke="#ffc306" fill="#ffc306" />
          <Area type="monotone" dataKey="debug" name="Debug"
            stackId="1" stroke="#7becef" fill="#7becef" />
          <Area type="monotone" dataKey="verbose" name="Verbose"
            stackId="1" stroke="#b3e528" fill="#b3e528" />
          {deployMarkerLines(logData)}
          <CartesianGrid stroke="#ccc" strokeDasharray="1 1" />
          <XAxis dataKey={(stat) => stat.time.toISOString()}
            tick={<GraphTimeTick />} stroke="#21a1b5"/>
          <YAxis axisLine={false} tickLine={false} tick={axisTickStyle}
            tickFormatter={tick => tick.toLocaleString()}/>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
});

export default LogsChartWidget;
